import { gql } from '@apollo/client';

export const GET_FINLEY_AI_THREADS = gql`
  query GetFinleyAiThreads($userId: UUID!) {
    getFinleyAiThreads(userId: $userId) {
      threads
    }
  }
`;

export const GET_FINLEY_AI_THREAD_WITH_PROMPT_RESPONSES = gql`
  query GetFinleyAiThreadWithPromptResponses($finleyAiThreadId: UUID!) {
    getFinleyAiThreadWithPromptResponses(finleyAiThreadId: $finleyAiThreadId) {
      threadWithPromptResponses
    }
  }
`;

export const GET_KNOWLEDGE_BASE_DOCUMENTS_BY_ORGANIZATION_ID = gql`
  query GetKnowledgeBaseDocumentsByOrganizationId($organizationId: UUID!) {
    getKnowledgeBaseDocumentsByOrganizationId(organizationId: $organizationId) {
      knowledgeBaseDocuments {
        id
        documentName
        s3Bucket
        s3Path
        documentType
        tags
        organizationId
        userId
        embeddedChunksS3Bucket
        embeddedChunksS3Path
      }
    }
  }
`;

export const GET_FINLEY_AI_PROMPT_RESPONSE = gql`
  query GetFinleyAiPromptResponse($finleyAiPromptResponseId: UUID!) {
    getFinleyAiPromptResponse(
      finleyAiPromptResponseId: $finleyAiPromptResponseId
    ) {
      promptResponse
    }
  }
`;

export const PRODUCE_FINLEY_AI_WORKLEASE = gql`
  mutation ProduceFinleyAiWorklease($params: FinleyAiRequest!) {
    produceFinleyAiWorklease(params: $params) {
      thread
    }
  }
`;

export const GET_ATHENA_SQL_GENERATION_SIGNED_URLS = gql`
  query getAthenaSqlGenerationSignedUrls($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "athenaSqlGeneration"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_KNOWLEDGE_BASE_DOCUMENT_SIGNED_URLS = gql`
  query getKnowledgeBaseDocumentSignedUrl($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "knowledgeBaseDocument"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_FINLEY_AI_ATHENA_SQL_GENERATION_PROMPT_RESULT_PREVIEW = gql`
  query getFinleyAiAthenaSqlGenerationPromptResultPreview(
    $finleyAiPromptResponseId: UUID!
    $numberOfPreviewRows: Int
  ) {
    getFinleyAiAthenaSqlGenerationPromptResultPreview(
      finleyAiPromptResponseId: $finleyAiPromptResponseId
      numberOfPreviewRows: $numberOfPreviewRows
    )
  }
`;

export const GET_FINLEY_AI_EXTRACT_VALUES_UPLOAD_SIGNED_URL = gql`
  query getFinleyAiExtractValuesUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "finleyAiExtractValues"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_FINLEY_AI_VIRTUAL_SHEET_UPLOAD_SIGNED_URL = gql`
  query getFinleyAiVirtualSheetUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "finleyAiVirtualSheet"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_FINLEY_AI_TRANSFORM_UPLOAD_SIGNED_URL = gql`
  query getFinleyAiTransformUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "finleyAiTransform"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_VIRTUAL_SHEET_SIGNED_URLS = gql`
  query getFinleyAiVirtualSheetSignedUrls($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "finleyAiVirtualSheet"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_TRANSFORM_SIGNED_URLS = gql`
  query getFinleyAiTransformSignedUrls($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "finleyAiTransform"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_FINLEY_AI_DOCUMENT_AMA_UPLOAD_SIGNED_URL = gql`
  query getFinleyAiDocumentAmaUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "finleyAiDocumentAmaUpload"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;
